import { BehaviorSubject } from 'rxjs';
export const getDocumentDetailsStore = () => {
    const getInitialState = () => ({
        clientName: '',
        companyName: '',
        fileName: '',
        fileSize: null,
        calculationsAssociations: []
    });
    const documentDetailsSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => documentDetailsSubject.subscribe(callback);
    const setDocumentDetails = (details) => {
        documentDetailsSubject.next(details);
    };
    const reset = () => {
        documentDetailsSubject.next(getInitialState());
    };
    return {
        getInitialState,
        subscribe,
        setDocumentDetails,
        reset
    };
};
